export const ANALYTICS_URL = '/dashboard';
export const SIGNIN_URL = '/signin';
export const SIGNUP_URL = '/signup';
export const PERSONALDATA_URL = '/personaldata';
export const HOME_URL = '/';
export const DOC_URL= '/doc';
export const HELP_URL = '/help';
// export const PUBLIC_URL='/lexicoscope_beta';
export const PUBLIC_URL='/lexicoscope_2.0';
// export const SERVER_URL='http://lexicoscope.huma-num.fr'
export const SERVER_URL='http://phraseotext.univ-grenoble-alpes.fr'
export const ROOT_PATH='/var/www/html/lexicoscope_2.0';
export const ROOT_PATH_REGEX=/.var.www.html.lexicoscope_[^\\/]*|.media.ssd.lexicoscope.hash|.media.data.lexicoscope/;
export const MAX_CHART_SIZE=50;
export const PREDEFINED_CORPORA_DIR="/predefined_corpora";
